import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import {
  IconType,
  NavItem,
  NavItemsId,
  NavItemsType,
  PtPermissions,
  PtUiAppRoutes,
} from '@pt/pt-models';
import { of } from 'rxjs';
import { ApiClientConfig, AppId, DeveloperModeService } from '@pt/api-client';

@Component({
  selector: 'pt-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarComponent {
  @Input() itemLeft: NavItem[];
  @Input() itemRight: NavItem[];
  protected readonly appId: AppId;
  protected readonly CONSOLE: AppId = 'primatoo-ui-console';
  protected readonly UI: AppId = 'primatoo-ui';

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public devMode: DeveloperModeService
  ) {
    this.appId = this.config.env.appId;
  }

  toggleDevMode() {
    this.devMode.toggle();
  }


  debugItem: NavItem = {
    id: NavItemsId.DEBUG,
    classCss: ['bg-danger', 'text-white', 'btn-debug'],
    type: NavItemsType.BUTTON,
    label: of('Debug'),
    permissEnabled: [],
    permissVisible: [PtPermissions.ENABLE_FOR_SYSTEM],
    routerLink: PtUiAppRoutes.DEBUG,
    tooltipEnabled: true,
    icon: { key: 'bug', type: IconType.IONIC_ICON, size: 18 },
  };
}
